import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';

export const Tab = (props: MuiTabProps) => {
  return <MuiTab {...props} disableFocusRipple disableRipple disableTouchRipple />;
};
